@if (test) {
	<div>
		<div class="d-flex">
			<div class="col-12">
				<label>{{ "name" | langVal }}</label>
				<app-gen-input
					tabindex="1"
					[actualObj]="test"
					[errors]="errors"
					fieldName="name"
					autofocus="autofocus"
					(changeEvent)="validateAndSave('name')"
					[disabled]="test.is_locked == 'yes'"
				>
				</app-gen-input>
			</div>
		</div>
		<div class="d-flex">
			<div class="col-12">
				<label>{{ "short_name" | langVal }}</label>
				<app-gen-input
					tabindex="-1"
					[actualObj]="test"
					[errors]="errors"
					fieldName="short_name"
					(changeEvent)="validateAndSave('short_name')"
					[disabled]="test.is_locked == 'yes'"
				>
				</app-gen-input>
			</div>
		</div>
		@if (test.description) {
			<div class="d-flex">
				<div class="form-group col-12">
					<label class="description">{{ "description" | langVal }}</label>
					<app-wysiwyg
						tabindex="-1"
						[actualObj]="test"
						[errors]="errors"
						fieldName="description"
						(changeEvent)="validateAndSave('description')"
						[isStatic]="test.is_locked == 'yes'"
					>
					</app-wysiwyg>
				</div>
			</div>
		}
		<div class="d-flex">
			<div class="col-6 col-md-2">
				<label>{{ "language" | langVal }}</label>
				<app-gen-select
					[actualObj]="test"
					[errors]="errors"
					fieldName="lang"
					tabindex="64"
					(changeEvent)="validateAndSave('lang')"
					optionsListName="langOpts"
					optionFieldId="value"
				/>
			</div>
		</div>
		<div class="d-flex">
			<div class="form-group col-12">
				<label class="remarks">{{ "remarks" | langVal }}</label>
				<app-wysiwyg
					tabindex="-1"
					[actualObj]="test"
					[errors]="errors"
					fieldName="remarks"
					(changeEvent)="validateAndSave('remarks')"
					[isStatic]="test.is_locked == 'yes'"
				>
				</app-wysiwyg>
			</div>
		</div>
	</div>

	@if (permsService?.perms?.administrative && !test?.tests?.length && test.id) {
		<p
			class="followup-title"
			(click)="testquestionsIsOpen = !testquestionsIsOpen"
		>
			<app-icon [icon]="testquestionsIsOpen ? 'narrow' : 'expand'" />
			<span class="pointer"> {{ "questions" | langVal }} </span>
		</p>
		@if (testquestionsIsOpen) {
			<app-testquestions-manage
				[test_id]="test.id"
				[is_locked]="test.is_locked || ''"
			/>
		}
		<p class="followup-title">{{ "properties" | langVal }}</p>

		<div class="d-flex flex-wrap align-items-end gap-3 mb-4 py-4">
			<!--    <div class="col-3   col-lg-2" >-->
			<!--      <label>{{"for_patient" | langVal}}</label>-->
			<!--        <app-gen-button-group [actualObj]="test" fieldName="for_patient" optionsListName="yes_no_opts"-->
			<!--                              (changeEvent)="validateAndSave('for_patient')" [disabled]="test.is_locked=='yes'" ></app-gen-button-group>-->

			<!--    </div>-->
			<div>
				<app-gen-button-group
					[actualObj]="test"
					fieldName="patient_sign_required"
					optionsListName="patient_sign_required_opts"
					(changeEvent)="validateAndSave('patient_sign_required')"
					[disabled]="test.is_locked == 'yes'"
				/>
			</div>
			<div>
				<app-gen-button-group
					[actualObj]="test"
					fieldName="user_sign_required"
					optionsListName="user_sign_required_opts"
					(changeEvent)="validateAndSave('user_sign_required')"
					[disabled]="test.is_locked == 'yes'"
				/>
			</div>
			<!-- <div>
        <app-gen-button-group
          [actualObj]="test"
          fieldName="active"
          optionsListName="active_opts"
          (changeEvent)="validateAndSave('active')"
        ></app-gen-button-group>
      </div> -->
			<div>
				<app-gen-button-group
					[actualObj]="test"
					fieldName="is_locked"
					optionsListName="locked_opts"
					(changeEvent)="validateAndSave('is_locked')"
				></app-gen-button-group>
			</div>
			<div>
				<app-gen-button-group
					[actualObj]="test"
					fieldName="calculated"
					optionsListName="calculated_opts"
					(changeEvent)="validateAndSave('calculated')"
				></app-gen-button-group>
			</div>
			@if (test.id && !test.test_id) {
				<div>
					<app-spin-or-content [isSpin]="spinDup">
						<button
							class="btn btn-primary"
							(click)="duplicateTest()"
							titleLang="duplicate_test"
						>
							{{ "duplicate_test" | langVal }}
						</button>
					</app-spin-or-content>
				</div>
			}
		</div>
		@if (test?.calculated == "yes") {
			<p class="followup-title">
				<app-icon
					[icon]="testscalesIsOpen ? 'narrow' : 'expand'"
					(click)="testscalesIsOpen = !testscalesIsOpen"
				/>
				{{ "scales" | langVal }}
			</p>
			@if (testscalesIsOpen) {
				<app-testscales [test_id]="test.id" />
			}
		}
	}
	<div class="modal-btns">
		<app-btn-ext
			text="exit"
			(clickEv)="onClose.emit()"
		/>
		@if (!test.id) {
			<app-btn-ext
				text="add"
				[disabled]="!isFormSubmittable"
				(clickEv)="save()"
				[isSpin]="isSaving"
			/>
		}
	</div>
}
